import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import './index.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { title, sub_title, more_btn_text, more_btn_href, list = [] } = data;
    const has_right_btn = !!more_btn_text && !!more_btn_href;
    return (
        <GloLayout className={`editor-index-list-c1`} id={id} data={data}>
            <div className="index-list-c1-title eco-content-v2">
                <div>
                    <h2 className="index-list-c1-title-l">{title}</h2>
                    <div className="index-list-c1-subtitle-l">{sub_title}</div>
                </div>
                {has_right_btn && (
                    <EcoLink href={more_btn_href} className="index-list-c1-more-btn index-list-c1-title-r">
                        {more_btn_text}
                        <span className="index-list-c1-arrow"></span>
                    </EcoLink>
                )}
            </div>
            <Swiper className="index-list-c1-list-swiper" modules={[Navigation]} navigation spaceBetween={12} slidesPerView="auto">
                {list.map((item: any, idx: number) => (
                    <SwiperSlide className="index-list-c1-list-swiper-slide" key={idx}>
                        <EcoLink className="index-list-c1-list-item" href={item.href}>
                            <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} className="index-list-c1-item-img" />
                            <div className="index-list-c1-item-msg">
                                <div className="index-list-c1-item-title">{item.title}</div>
                                {!!item.desc && (
                                    <div className="index-list-c1-item-desc">
                                        <span className="index-list-c1-item-desc-text">{item.desc}</span>
                                        <span className="index-list-c1-item-arrow"></span>
                                    </div>
                                )}
                            </div>
                        </EcoLink>
                    </SwiperSlide>
                ))}
            </Swiper>

            {has_right_btn && (
                <EcoLink href={more_btn_href} className="index-list-c1-more-btn index-list-c1-f-btn">
                    {more_btn_text}
                    <span className="index-list-c1-arrow"></span>
                </EcoLink>
            )}
        </GloLayout>
    );
}
